// extracted by mini-css-extract-plugin
export default {"textlabel":"styles_textlabel__BzbnM"};